{
  "boosters": {
    "free": {
      "name": "Free Booster",
      "short": "Free",
      "description": "Every rarity, with a very small chance above Epic. A reserve that refills in one hour."
    },
    "standard": {
      "name": "Standard Booster",
      "short": "Standard",
      "description": "Every rarity, with better odds of landing on Uncommon and Rare."
    },
    "premium": {
      "name": "Premium Booster",
      "short": "Premium",
      "description": "Every rarity, with a curve centred on Rare and good odds of Epic."
    },
    "legendary": {
      "name": "Lucky Booster",
      "short": "Lucky",
      "description": "Every rarity, with a curve strongly favouring the higher rarities."
    }
  },
  "rarities": {
    "common": "Common",
    "uncommon": "Uncommon",
    "rare": "Rare",
    "epic": "Epic",
    "legendary": "Legendary",
    "mythic": "Mythic",
    "divine": "Divine",
    "senita": "Senita"
  },
  "roles": {
    "MAIN": "Main",
    "SUPPORTING": "Supporting",
    "BACKGROUND": "Background"
  },
  "categories": {
    "economy": "Economy",
    "collection": "Collection",
    "forge": "Forge",
    "boosters": "Boosters",
    "market": "Market",
    "social": "Social",
    "dedication": "Dedication"
  },
  "upgrades": {
    "1": "Base card",
    "2": "Custom nickname",
    "3": "Name color",
    "4": "Custom border",
    "5": "Card emblem",
    "6": "Colored halo",
    "7": "Holographic finish",
    "8": "Personal signature",
    "9": "Animated aura",
    "10": "Awakened portrait"
  },
  "quests": {
    "booster_opened": {
      "v0": {
        "title": "Open boosters",
        "description_one": "Open 1 booster, free or paid.",
        "description_other": "Open {{count}} boosters, free or paid."
      },
      "v1": {
        "title": "Any pack",
        "description_one": "Open 1 booster of any type.",
        "description_other": "Open {{count}} boosters of any type."
      },
      "v2": {
        "title": "Opening counter",
        "description_one": "Open 1 booster in total.",
        "description_other": "Open {{count}} boosters in total."
      },
      "title": "Open boosters",
      "description_one": "Open 1 booster, free or paid.",
      "description_other": "Open {{count}} boosters, free or paid."
    },
    "character_new": {
      "v0": {
        "title": "New characters",
        "description_one": "Obtain 1 character you did not own.",
        "description_other": "Obtain {{count}} characters you did not own."
      },
      "v1": {
        "title": "New faces",
        "description_one": "Add 1 new character to your binder.",
        "description_other": "Add {{count}} new characters to your binder."
      },
      "v2": {
        "title": "Blank slots",
        "description_one": "Fill 1 empty slot in your collection.",
        "description_other": "Fill {{count}} empty slots in your collection."
      },
      "title": "New characters",
      "description_one": "Obtain 1 character you did not own.",
      "description_other": "Obtain {{count}} characters you did not own."
    },
    "character_duplicate": {
      "v0": {
        "title": "Duplicates",
        "description_one": "Obtain 1 character you already own.",
        "description_other": "Obtain {{count}} characters you already own."
      },
      "v1": {
        "title": "Old friends",
        "description_one": "Pull 1 character you already owned.",
        "description_other": "Pull {{count}} characters you already owned."
      },
      "v2": {
        "title": "Extra copies",
        "description_one": "Collect 1 duplicate card.",
        "description_other": "Collect {{count}} duplicate cards."
      },
      "title": "Duplicates",
      "description_one": "Obtain 1 character you already own.",
      "description_other": "Obtain {{count}} characters you already own."
    },
    "auction_bid": {
      "v0": {
        "title": "Auctions",
        "description_one": "Create an auction or place 1 bid.",
        "description_other": "Create auctions or place {{count}} bids."
      },
      "v1": {
        "title": "On the hammer",
        "description_one": "Start or raise 1 auction.",
        "description_other": "Start or raise {{count}} auctions."
      },
      "v2": {
        "title": "Auction room",
        "description_one": "Take part in 1 auction.",
        "description_other": "Take part in {{count}} auctions."
      },
      "title": "Auctions",
      "description_one": "Create an auction or place 1 bid.",
      "description_other": "Create auctions or place {{count}} bids."
    },
    "collection_viewed": {
      "v0": {
        "title": "View your collection",
        "description_one": "Open your collection page once.",
        "description_other": "Open your collection page once."
      },
      "v1": {
        "title": "Binder tour",
        "description_one": "Browse your collection once.",
        "description_other": "Browse your collection once."
      },
      "v2": {
        "title": "Inventory",
        "description_one": "Look at your cards once.",
        "description_other": "Look at your cards once."
      },
      "title": "View your collection",
      "description_one": "Open your collection page once.",
      "description_other": "Open your collection page once.",
      "description": "Open your collection page once."
    },
    "free_booster_opened": {
      "v0": {
        "title": "Free booster",
        "description_one": "Open 1 free booster.",
        "description_other": "Open {{count}} free boosters."
      },
      "v1": {
        "title": "Daily reserve",
        "description_one": "Spend 1 free reserve charge.",
        "description_other": "Spend {{count}} free reserve charges."
      },
      "v2": {
        "title": "Free packs",
        "description_one": "Open 1 free pack.",
        "description_other": "Open {{count}} free packs."
      },
      "title": "Free booster",
      "description_one": "Open 1 free booster.",
      "description_other": "Open {{count}} free boosters."
    },
    "premium_booster_opened": {
      "v0": {
        "title": "Premium booster",
        "description_one": "Open 1 Premium booster.",
        "description_other": "Open {{count}} Premium boosters."
      },
      "v1": {
        "title": "Golden packs",
        "description_one": "Open 1 Premium pack.",
        "description_other": "Open {{count}} Premium packs."
      },
      "v2": {
        "title": "Above the rest",
        "description_one": "Try 1 Premium opening.",
        "description_other": "Try {{count}} Premium openings."
      },
      "title": "Premium booster",
      "description_one": "Open 1 Premium booster.",
      "description_other": "Open {{count}} Premium boosters."
    },
    "legendary_booster_opened": {
      "v0": {
        "title": "Lucky booster",
        "description_one": "Open 1 Lucky booster.",
        "description_other": "Open {{count}} Lucky boosters."
      },
      "v1": {
        "title": "Rare packs",
        "description_one": "Open 1 Lucky pack.",
        "description_other": "Open {{count}} Lucky packs."
      },
      "v2": {
        "title": "Lucky break",
        "description_one": "Try 1 Lucky opening.",
        "description_other": "Try {{count}} Lucky openings."
      },
      "title": "Lucky booster",
      "description_one": "Open 1 Lucky booster.",
      "description_other": "Open {{count}} Lucky boosters."
    },
    "rare_or_better_obtained": {
      "v0": {
        "title": "Rare or better",
        "description_one": "Obtain 1 Rare or higher rarity character.",
        "description_other": "Obtain {{count}} Rare or higher rarity characters."
      },
      "v1": {
        "title": "Splash of color",
        "description_one": "Pull 1 Rare, Epic, Legendary, Mythic or Divine card.",
        "description_other": "Pull {{count}} Rare or better cards."
      },
      "v2": {
        "title": "Above common",
        "description_one": "Land 1 Rare or higher rarity.",
        "description_other": "Land {{count}} Rare or higher rarities."
      },
      "title": "Rare or better",
      "description_one": "Obtain 1 Rare or higher rarity character.",
      "description_other": "Obtain {{count}} Rare or higher rarity characters."
    },
    "epic_or_better_obtained": {
      "v0": {
        "title": "Epic or better",
        "description_one": "Obtain 1 Epic or higher rarity character.",
        "description_other": "Obtain {{count}} Epic or higher rarity characters."
      },
      "v1": {
        "title": "Violet halo",
        "description_one": "Pull 1 Epic, Legendary, Mythic or Divine card.",
        "description_other": "Pull {{count}} Epic or better cards."
      },
      "v2": {
        "title": "Fine vintage",
        "description_one": "Land 1 Epic or higher rarity.",
        "description_other": "Land {{count}} Epic or higher rarities."
      },
      "title": "Epic or better",
      "description_one": "Obtain 1 Epic or higher rarity character.",
      "description_other": "Obtain {{count}} Epic or higher rarity characters."
    },
    "card_upgraded": {
      "v0": {
        "title": "Upgrade cards",
        "description_one": "Upgrade a card 1 time.",
        "description_other": "Upgrade cards {{count}} times."
      },
      "v1": {
        "title": "Workshop",
        "description_one": "Raise a card by 1 level.",
        "description_other": "Raise cards by {{count}} levels in total."
      },
      "v2": {
        "title": "Leveling up",
        "description_one": "Perform 1 card upgrade.",
        "description_other": "Perform {{count}} card upgrades."
      },
      "title": "Upgrade cards",
      "description_one": "Upgrade a card 1 time.",
      "description_other": "Upgrade cards {{count}} times."
    },
    "fragments_spent": {
      "v0": {
        "title": "Fragments spent",
        "description_one": "Spend 1 fragment on card upgrades.",
        "description_other": "Spend {{count}} fragments on card upgrades."
      },
      "v1": {
        "title": "Forge",
        "description_one": "Burn 1 fragment in the forge.",
        "description_other": "Burn {{count}} fragments in the forge."
      },
      "v2": {
        "title": "Investment",
        "description_one": "Invest 1 fragment in a card.",
        "description_other": "Invest {{count}} fragments in your cards."
      },
      "title": "Fragments spent",
      "description_one": "Spend 1 fragment on card upgrades.",
      "description_other": "Spend {{count}} fragments on card upgrades."
    },
    "fragments_earned": {
      "v0": {
        "title": "Fragments earned",
        "description_one": "Earn 1 fragment.",
        "description_other": "Earn {{count}} fragments."
      },
      "v1": {
        "title": "Shard harvest",
        "description_one": "Pick up 1 fragment.",
        "description_other": "Pick up {{count}} fragments."
      },
      "v2": {
        "title": "Crystal loot",
        "description_one": "Accumulate 1 fragment.",
        "description_other": "Accumulate {{count}} fragments."
      },
      "title": "Fragments earned",
      "description_one": "Earn 1 fragment.",
      "description_other": "Earn {{count}} fragments."
    },
    "listing_created": {
      "v0": {
        "title": "Listings created",
        "description_one": "Publish 1 listing on the market.",
        "description_other": "Publish {{count}} listings on the market."
      },
      "v1": {
        "title": "Cards on display",
        "description_one": "Put 1 card up for sale.",
        "description_other": "Put {{count}} cards up for sale."
      },
      "v2": {
        "title": "Price tag",
        "description_one": "Create 1 sale listing.",
        "description_other": "Create {{count}} sale listings."
      },
      "title": "Listings created",
      "description_one": "Publish 1 listing on the market.",
      "description_other": "Publish {{count}} listings on the market."
    },
    "market_purchase": {
      "v0": {
        "title": "Market purchases",
        "description_one": "Buy 1 card on the market.",
        "description_other": "Buy {{count}} cards on the market."
      },
      "v1": {
        "title": "Good deal",
        "description_one": "Complete 1 market purchase.",
        "description_other": "Complete {{count}} market purchases."
      },
      "v2": {
        "title": "Shopping bag",
        "description_one": "Acquire 1 card from the market.",
        "description_other": "Acquire {{count}} cards from the market."
      },
      "title": "Market purchases",
      "description_one": "Buy 1 card on the market.",
      "description_other": "Buy {{count}} cards on the market."
    },
    "trade_proposed": {
      "v0": {
        "title": "Trades proposed",
        "description_one": "Propose 1 trade.",
        "description_other": "Propose {{count}} trades."
      },
      "v1": {
        "title": "Open hand",
        "description_one": "Send 1 trade offer.",
        "description_other": "Send {{count}} trade offers."
      },
      "v2": {
        "title": "Negotiating table",
        "description_one": "Start 1 trade negotiation.",
        "description_other": "Start {{count}} trade negotiations."
      },
      "title": "Trades proposed",
      "description_one": "Propose 1 trade.",
      "description_other": "Propose {{count}} trades."
    },
    "trade_completed": {
      "v0": {
        "title": "Trades completed",
        "description_one": "Complete 1 trade.",
        "description_other": "Complete {{count}} trades."
      },
      "v1": {
        "title": "Deal sealed",
        "description_one": "Close 1 accepted trade.",
        "description_other": "Close {{count}} accepted trades."
      },
      "v2": {
        "title": "Final handshake",
        "description_one": "Finish 1 swap.",
        "description_other": "Finish {{count}} swaps."
      },
      "title": "Trades completed",
      "description_one": "Complete 1 trade.",
      "description_other": "Complete {{count}} trades."
    },
    "system_sale": {
      "v0": {
        "title": "System resales",
        "description_one": "Sell 1 card back to the system.",
        "description_other": "Sell {{count}} cards back to the system."
      },
      "v1": {
        "title": "Making room",
        "description_one": "Let 1 card go to the system.",
        "description_other": "Let {{count}} cards go to the system."
      },
      "v2": {
        "title": "Instant buyback",
        "description_one": "Give 1 card to the system buyback.",
        "description_other": "Give {{count}} cards to the system buyback."
      },
      "title": "System resales",
      "description_one": "Sell 1 card back to the system.",
      "description_other": "Sell {{count}} cards back to the system."
    },
    "anima_spent": {
      "v0": {
        "title": "Anima spent",
        "description_one": "Spend 1 Anima.",
        "description_other": "Spend {{count}} Anima."
      },
      "v1": {
        "title": "Open purse",
        "description_one": "Let go of 1 Anima.",
        "description_other": "Let go of {{count}} Anima."
      },
      "v2": {
        "title": "Staked",
        "description_one": "Commit 1 Anima.",
        "description_other": "Commit {{count}} Anima."
      },
      "title": "Anima spent",
      "description_one": "Spend 1 Anima.",
      "description_other": "Spend {{count}} Anima."
    },
    "message_sent": {
      "v0": {
        "title": "Messages sent",
        "description_one": "Send 1 private message.",
        "description_other": "Send {{count}} private messages."
      },
      "v1": {
        "title": "Speaking up",
        "description_one": "Write 1 message to a friend.",
        "description_other": "Write {{count}} messages to your friends."
      },
      "v2": {
        "title": "Thread",
        "description_one": "Post 1 message.",
        "description_other": "Post {{count}} messages."
      },
      "title": "Messages sent",
      "description_one": "Send 1 private message.",
      "description_other": "Send {{count}} private messages."
    },
    "card_shared": {
      "v0": {
        "title": "Cards shared",
        "description_one": "Share 1 card in a conversation.",
        "description_other": "Share {{count}} cards in conversations."
      },
      "v1": {
        "title": "Showing off",
        "description_one": "Show 1 card in a message.",
        "description_other": "Show {{count}} cards in your messages."
      },
      "v2": {
        "title": "Postcard",
        "description_one": "Send 1 card to a friend.",
        "description_other": "Send {{count}} cards to your friends."
      },
      "title": "Cards shared",
      "description_one": "Share 1 card in a conversation.",
      "description_other": "Share {{count}} cards in conversations."
    },
    "reaction_given": {
      "v0": {
        "title": "Reactions",
        "description_one": "React 1 time to a message.",
        "description_other": "React {{count}} times to messages."
      },
      "v1": {
        "title": "Little sign",
        "description_one": "Leave 1 reaction.",
        "description_other": "Leave {{count}} reactions."
      },
      "v2": {
        "title": "Emoji",
        "description_one": "Add 1 reaction to a message.",
        "description_other": "Add {{count}} reactions to messages."
      },
      "title": "Reactions",
      "description_one": "React 1 time to a message.",
      "description_other": "React {{count}} times to messages."
    },
    "friend_request_sent": {
      "v0": {
        "title": "Friend request",
        "description_one": "Send 1 friend request.",
        "description_other": "Send 1 friend request."
      },
      "v1": {
        "title": "New contact",
        "description_one": "Reach out to 1 player.",
        "description_other": "Reach out to 1 player."
      },
      "v2": {
        "title": "Invitation",
        "description_one": "Invite 1 player as a friend.",
        "description_other": "Invite 1 player as a friend."
      },
      "title": "Friend request",
      "description_one": "Send 1 friend request.",
      "description_other": "Send 1 friend request."
    },
    "profile_viewed": {
      "v0": {
        "title": "Profiles visited",
        "description_one": "Open another player’s profile.",
        "description_other": "Open another player’s profile."
      },
      "v1": {
        "title": "Curiosity",
        "description_one": "Go see 1 player profile.",
        "description_other": "Go see 1 player profile."
      },
      "v2": {
        "title": "Drop by",
        "description_one": "View 1 player page.",
        "description_other": "View 1 player page."
      },
      "title": "Profiles visited",
      "description_one": "Open another player’s profile.",
      "description_other": "Open another player’s profile."
    },
    "collection_compared": {
      "v0": {
        "title": "Compare a collection",
        "description_one": "Compare your collection to another player’s.",
        "description_other": "Compare your collection to another player’s."
      },
      "v1": {
        "title": "Face to face",
        "description_one": "Put your binder next to another one.",
        "description_other": "Put your binder next to another one."
      },
      "v2": {
        "title": "Who has what",
        "description_one": "Check what you are missing on a player.",
        "description_other": "Check what you are missing on a player."
      },
      "title": "Compare a collection",
      "description_one": "Compare your collection to another player’s.",
      "description_other": "Compare your collection to another player’s."
    },
    "showcase_edited": {
      "v0": {
        "title": "Showcase edited",
        "description_one": "Edit your showcase once.",
        "description_other": "Edit your showcase once."
      },
      "v1": {
        "title": "New storefront",
        "description_one": "Rearrange your displayed cards.",
        "description_other": "Rearrange your displayed cards."
      },
      "v2": {
        "title": "Shelf",
        "description_one": "Touch up a showcase slot.",
        "description_other": "Touch up a showcase slot."
      },
      "title": "Showcase edited",
      "description_one": "Edit your showcase once.",
      "description_other": "Edit your showcase once."
    },
    "favorite_added": {
      "v0": {
        "title": "New favorites",
        "description_one": "Set 1 character as a favorite.",
        "description_other": "Set {{count}} characters as favorites."
      },
      "v1": {
        "title": "Star",
        "description_one": "Pin 1 card as a favorite.",
        "description_other": "Pin {{count}} cards as favorites."
      },
      "v2": {
        "title": "Crush",
        "description_one": "Mark 1 character as a favorite.",
        "description_other": "Mark {{count}} characters as favorites."
      },
      "title": "New favorites",
      "description_one": "Set 1 character as a favorite.",
      "description_other": "Set {{count}} characters as favorites."
    },
    "cosmetic_equipped": {
      "v0": {
        "title": "Change style",
        "description_one": "Equip 1 cosmetic.",
        "description_other": "Equip 1 cosmetic."
      },
      "v1": {
        "title": "New look",
        "description_one": "Wear a title, badge, frame or filter.",
        "description_other": "Wear a title, badge, frame or filter."
      },
      "v2": {
        "title": "Fitting",
        "description_one": "Apply 1 cosmetic to your profile.",
        "description_other": "Apply 1 cosmetic to your profile."
      },
      "title": "Change style",
      "description_one": "Equip 1 cosmetic.",
      "description_other": "Equip 1 cosmetic."
    },
    "login_claimed": {
      "v0": {
        "title": "Today’s login",
        "description_one": "Claim the calendar login reward.",
        "description_other": "Claim the calendar login reward."
      },
      "v1": {
        "title": "Present",
        "description_one": "Check in on the calendar once.",
        "description_other": "Check in on the calendar once."
      },
      "v2": {
        "title": "Ritual",
        "description_one": "Collect the daily calendar bonus.",
        "description_other": "Collect the daily calendar bonus."
      },
      "title": "Today’s login",
      "description_one": "Claim the calendar login reward.",
      "description_other": "Claim the calendar login reward."
    },
    "anime_completed": {
      "v0": {
        "title": "Animes completed",
        "description_one": "Complete 1 anime.",
        "description_other": "Complete {{count}} animes."
      },
      "v1": {
        "title": "Series done",
        "description_one": "Finish 1 series.",
        "description_other": "Finish {{count}} series."
      },
      "v2": {
        "title": "One hundred percent",
        "description_one": "Complete 1 anime to 100%.",
        "description_other": "Complete {{count}} animes to 100%."
      },
      "title": "Animes completed",
      "description_one": "Complete 1 anime.",
      "description_other": "Complete {{count}} animes."
    },
    "achievement_unlocked": {
      "v0": {
        "title": "Achievements unlocked",
        "description_one": "Unlock 1 achievement.",
        "description_other": "Unlock {{count}} achievements."
      },
      "v1": {
        "title": "Trophies",
        "description_one": "Earn 1 trophy.",
        "description_other": "Earn {{count}} trophies."
      },
      "v2": {
        "title": "Hall of fame",
        "description_one": "Add 1 achievement to your board.",
        "description_other": "Add {{count}} achievements to your board."
      },
      "title": "Achievements unlocked",
      "description_one": "Unlock 1 achievement.",
      "description_other": "Unlock {{count}} achievements."
    },
    "quest_claimed": {
      "v0": {
        "title": "Quests claimed",
        "description_one": "Claim 1 other completed quest.",
        "description_other": "Claim {{count}} other completed quests."
      },
      "v1": {
        "title": "Reward cashed",
        "description_one": "Cash in 1 completed quest.",
        "description_other": "Cash in {{count}} completed quests."
      },
      "v2": {
        "title": "Board cleared",
        "description_one": "Validate 1 quest.",
        "description_other": "Validate {{count}} quests."
      },
      "title": "Quests claimed",
      "description_one": "Claim 1 other completed quest.",
      "description_other": "Claim {{count}} other completed quests."
    }
  },
  "achievements": {
    "anima_balance": {
      "title": "Anima",
      "description_one": "Hold {{formatted}} Anima.",
      "description_other": "Hold {{formatted}} Anima."
    },
    "anima_spent": {
      "title": "Big spender",
      "description_one": "Spend {{formatted}} Anima on boosters.",
      "description_other": "Spend {{formatted}} Anima on boosters."
    },
    "unique_characters": {
      "title": "Completion",
      "description_one": "Own {{formatted}} different character.",
      "description_other": "Own {{formatted}} different characters."
    },
    "owned_common": {
      "title": "Commons",
      "description_one": "Own {{formatted}} Common character.",
      "description_other": "Own {{formatted}} Common characters."
    },
    "owned_uncommon": {
      "title": "Uncommons",
      "description_one": "Own {{formatted}} Uncommon character.",
      "description_other": "Own {{formatted}} Uncommon characters."
    },
    "owned_rare": {
      "title": "Rares",
      "description_one": "Own {{formatted}} Rare character.",
      "description_other": "Own {{formatted}} Rare characters."
    },
    "owned_epic": {
      "title": "Epics",
      "description_one": "Own {{formatted}} Epic character.",
      "description_other": "Own {{formatted}} Epic characters."
    },
    "owned_legendary": {
      "title": "Legendaries",
      "description_one": "Own {{formatted}} Legendary character.",
      "description_other": "Own {{formatted}} Legendary characters."
    },
    "owned_mythic": {
      "title": "Mythics",
      "description_one": "Own {{formatted}} Mythic character.",
      "description_other": "Own {{formatted}} Mythic characters."
    },
    "owned_divine": {
      "title": "Divines",
      "description_one": "Own {{formatted}} Divine character.",
      "description_other": "Own {{formatted}} Divine characters."
    },
    "owned_senita": {
      "title": "Senita",
      "description_one": "Own {{formatted}} Senita character.",
      "description_other": "Own {{formatted}} Senita characters."
    },
    "animes_completed": {
      "title": "Complete series",
      "description_one": "Complete {{formatted}} anime.",
      "description_other": "Complete {{formatted}} anime."
    },
    "fragments_earned": {
      "title": "Fragments",
      "description_one": "Earn {{formatted}} fragment.",
      "description_other": "Earn {{formatted}} fragments."
    },
    "fragments_spent": {
      "title": "Smelter",
      "description_one": "Spend {{formatted}} fragment.",
      "description_other": "Spend {{formatted}} fragments."
    },
    "upgrades": {
      "title": "Blacksmith",
      "description_one": "Upgrade a card {{formatted}} time.",
      "description_other": "Upgrade cards {{formatted}} times."
    },
    "boosters_opened": {
      "title": "Opener",
      "description_one": "Open {{formatted}} booster.",
      "description_other": "Open {{formatted}} boosters."
    },
    "lucky_boosters_opened": {
      "title": "Lucky",
      "description_one": "Open {{formatted}} Lucky Booster.",
      "description_other": "Open {{formatted}} Lucky Boosters."
    },
    "trades_completed": {
      "title": "Trader",
      "description_one": "Complete {{formatted}} trade.",
      "description_other": "Complete {{formatted}} trades."
    },
    "listing_sales": {
      "title": "Seller",
      "description_one": "Sell {{formatted}} card on the market.",
      "description_other": "Sell {{formatted}} cards on the market."
    },
    "listing_purchases": {
      "title": "Buyer",
      "description_one": "Buy {{formatted}} card on the market.",
      "description_other": "Buy {{formatted}} cards on the market."
    },
    "auctions_sold": {
      "title": "Auctioneer",
      "description_one": "Sell {{formatted}} card at auction.",
      "description_other": "Sell {{formatted}} cards at auction."
    },
    "auctions_won": {
      "title": "Top bidder",
      "description_one": "Win {{formatted}} auction.",
      "description_other": "Win {{formatted}} auctions."
    },
    "bids_placed": {
      "title": "Raised hand",
      "description_one": "Place {{formatted}} bid.",
      "description_other": "Place {{formatted}} bids."
    },
    "friends_count": {
      "title": "Friends",
      "description_one": "Have {{formatted}} friend.",
      "description_other": "Have {{formatted}} friends."
    },
    "referrals_count": {
      "title": "Sponsor",
      "description_one": "Refer {{formatted}} verified player.",
      "description_other": "Refer {{formatted}} verified players."
    },
    "messages_sent": {
      "title": "Chatterbox",
      "description_one": "Send {{formatted}} message.",
      "description_other": "Send {{formatted}} messages."
    },
    "playtime_hours": {
      "title": "Playtime",
      "description_one": "Play for {{formatted}} hour.",
      "description_other": "Play for {{formatted}} hours."
    },
    "login_streak": {
      "title": "Streak",
      "description_one": "Log in {{formatted}} day in a row.",
      "description_other": "Log in {{formatted}} days in a row."
    },
    "login_days": {
      "title": "Regular",
      "description_one": "Log in on {{formatted}} day.",
      "description_other": "Log in on {{formatted}} days."
    },
    "account_age_days": {
      "title": "Veteran",
      "description_one": "Have an account {{formatted}} day old.",
      "description_other": "Have an account {{formatted}} days old."
    },
    "quests_completed": {
      "title": "Quests",
      "description_one": "Complete {{formatted}} quest.",
      "description_other": "Complete {{formatted}} quests."
    },
    "player_level": {
      "title": "Level",
      "description_one": "Reach level {{formatted}}.",
      "description_other": "Reach level {{formatted}}."
    }
  },
  "unlocks": {
    "title": {
      "premium_supporter": "ANIDEX Keeper",
      "senita_ascended": "Senita",
      "collector": "Collector",
      "living_encyclopedia": "Living encyclopedia",
      "mythic_ten": "Mythic pantheon",
      "master_smith": "Master smith",
      "booster_abyss": "Booster abyss",
      "merchant": "Merchant",
      "deal_maker": "Deal maker",
      "elite": "Elite",
      "social_hub": "Social hub",
      "page_turner": "Page turner",
      "lore_keeper": "Lore keeper",
      "myth_weaver": "Myth weaver",
      "star_archivist": "Star archivist",
      "gold_tongue": "Golden tongue",
      "vault_baron": "Vault baron",
      "auction_ghost": "Auction ghost",
      "pact_binder": "Pact binder",
      "anima_alchemist": "Anima alchemist",
      "ember_hand": "Ember hand",
      "shard_saint": "Shard saint",
      "awakening_bell": "Awakening bell",
      "forge_hymn": "Forge hymn",
      "pack_storm": "Pack storm",
      "pity_breaker": "Pity breaker",
      "lucky_fool": "Lucky fool",
      "divine_touch": "Finger of fate",
      "week_sentinel": "Week sentinel",
      "dawn_regular": "Dawn regular",
      "century_soul": "Century soul",
      "streak_comet": "Faithful comet",
      "friend_beacon": "Friend beacon",
      "salon_host": "Salon host",
      "whisper_net": "Whisper net",
      "reaction_heart": "Reactive heart",
      "neon_idol": "Neon idol",
      "glitch_prince": "Glitch prince",
      "sumi_poet": "Sumi poet",
      "pixel_hero": "Pixel hero",
      "frost_monarch": "Frost monarch",
      "gothic_relic": "Gothic relic",
      "terminal_root": "Terminal root",
      "stained_saint": "Stained saint",
      "stamp_official": "Official stamp",
      "manga_lead": "Lead role",
      "aurora_name": "Aurora name"
    },
    "badge": {
      "archive_keeper": "Archive keeper",
      "legendary_ten": "Court of legends",
      "insolent_luck": "Insolent luck",
      "first_divine": "Divine touch",
      "spent_forge": "Burning forge",
      "booster_storm": "Card tornado",
      "echo_chamber": "Echo chamber",
      "market_mogul": "Market collector",
      "quest_veteran": "Quest veteran",
      "streak_thirty": "Faithful month",
      "album_sprout": "Album sprout",
      "series_lantern": "Series lantern",
      "rare_spark": "Rare spark",
      "shard_chip": "Raw shard",
      "first_polish": "First polish",
      "curious_eye": "Curious eye",
      "deja_vu_mark": "Déjà-vu mark",
      "stall_bell": "Stall bell",
      "handshake": "Sealed handshake",
      "novice_ribbon": "Novice ribbon",
      "hex_dice": "Hex die",
      "fox_mask": "Kitsune mask",
      "torii_gate": "Torii gate",
      "hourglass": "Hourglass",
      "anchor": "Anchor",
      "comet": "Comet",
      "vial": "Vial",
      "sword_shield": "Sword and shield",
      "moon_rabbit": "Moon rabbit",
      "koi": "Koi",
      "cherry_seal": "Cherry seal",
      "oni_fang": "Oni fang",
      "shuriken": "Shuriken",
      "fan": "Folding fan",
      "lantern": "Lantern",
      "drum": "Drum",
      "wave_crest": "Wave crest",
      "crane": "Crane",
      "dragon_scale": "Dragon scale",
      "phoenix": "Phoenix",
      "ink_stamp": "Ink stamp",
      "vinyl": "Vinyl",
      "cassette": "Cassette",
      "pixel_coin": "Pixel coin",
      "neon_bolt": "Neon bolt",
      "frost_flake": "Frost flake",
      "ember_coal": "Ember",
      "vine": "Vine",
      "gear": "Gear",
      "crown_chip": "Crown chip"
    },
    "avatar": {
      "premium_stardust": "Stardust",
      "explorer": "Explorer compass",
      "petals": "Petals",
      "frost": "Frost",
      "neko_ears": "Neko ears",
      "horns": "Horns",
      "halo": "Halo",
      "wings": "Wings",
      "scanlines": "CRT scanlines",
      "glitch": "Glitch",
      "kitsune": "Kitsune",
      "summoning": "Summoning circle",
      "hud_reticle": "HUD reticle",
      "sparkles": "Sparkles",
      "rain": "Rain",
      "embers": "Embers",
      "bubbles": "Bubbles",
      "vines": "Vines",
      "static": "Analog static",
      "moonlight": "Moonlight",
      "sunglasses": "Sunglasses",
      "blush": "Blush",
      "demon_eyes": "Demon gaze",
      "angel_feathers": "Angel feathers",
      "pirate": "Pirate",
      "crown": "Crown",
      "headphones": "Headphones",
      "mask_oni": "Oni mask",
      "butterflies": "Butterflies",
      "constellation": "Constellation",
      "binary": "Binary rain"
    },
    "banner": {
      "premium_constellation": "Golden constellation",
      "senita_cosmos": "Senita Cosmos",
      "omnibus": "Omnibus",
      "divine_trio": "Celestial triad",
      "trade_baron": "Trade baron",
      "summit": "Summit",
      "team_spirit": "Team spirit",
      "aurora": "Aurora",
      "neon_rain": "Neon rain",
      "great_wave": "Great wave",
      "speed_lines": "Speed lines",
      "halftone": "Halftone",
      "code_rain": "Code rain",
      "sky_lanterns": "Sky lanterns",
      "nebula": "Nebula",
      "sakura_storm": "Sakura storm",
      "embers_fall": "Falling embers",
      "snow": "Snow",
      "lightning": "Lightning",
      "film_grain": "Film grain",
      "vhs": "VHS",
      "gold_dust": "Gold dust",
      "ink_wash": "Ink wash",
      "constellation": "Constellation",
      "grid": "Grid",
      "spotlight": "Spotlight",
      "confetti": "Confetti",
      "fireflies": "Fireflies",
      "ocean": "Ocean",
      "ashen": "Ash",
      "prism": "Prism",
      "shrine_night": "Shrine night"
    },
    "frame": {
      "premium_orbit": "Golden orbit",
      "senita_nebula": "Senita Nebula",
      "crystal": "Crystal frame",
      "awakened": "Awakened frame",
      "gold_filigree": "Gold filigree",
      "shimenawa": "Shimenawa",
      "thorns": "Thorns",
      "chains": "Chains",
      "rune_ring": "Runic ring",
      "dragon_scale": "Dragon scales",
      "gears": "Gears",
      "nacre": "Divine nacre",
      "laurel": "Laurel",
      "barbed": "Barbed wire",
      "halo_ring": "Halo ring",
      "pixel_bezel": "Pixel bezel",
      "neon_tube": "Neon tube",
      "ink_brush": "Ink brush",
      "frost_rim": "Frost rim",
      "flame_rim": "Flame rim",
      "gothic_arch": "Gothic arch",
      "circuit": "Circuit",
      "stained": "Stained glass",
      "stamp_edge": "Stamp edge",
      "manga_panel": "Manga panel",
      "aurora_ring": "Aurora ring",
      "obsidian": "Obsidian",
      "sakura": "Sakura",
      "chainmail": "Chainmail",
      "compass": "Compass rose",
      "eclipse": "Eclipse",
      "void_ring": "Void ring"
    }
  }
}
